module.exports = __webpack_public_path__ + "static/media/arrow-back.bd916665.svg";